import React, { useState, useEffect } from 'react';
import Images from '../../../../components/constant/Images';
import CareerTipSCardSection from './CareerTipSCardSection';
import CareerPagination from './CareerPagination';

const jobData = [
    {
        sliderImage: Images.CareerCardImageFour,
        sliderTitle: 'Setting Your Rates as an Accounting & Finance Professional',
        sliderDescription: "Determining your rates as an accounting professional can be challenging, but it's crucial for your business success. Start by researching the average rates for accountants and finance professionals with similar qualifications in your region. Consider your certifications, the complexity of the financial tasks, and the time required to complete them. Decide whether to charge hourly or offer fixed monthly retainers, keeping in mind that retainer packages often suit bookkeeping and payroll services best. Be transparent with clients about your rates and any additional costs. Don't undervalue your services; your expertise in managing finances is highly valuable. As you gain more experience and certifications, gradually increase your rates to reflect your growing expertise."
    },
    {
        sliderImage: Images.CareerCardImageFive,
        sliderTitle: 'Building a Client Base as an Accounting & Finance Professional',
        sliderDescription: "Building a solid client base is essential for a successful accounting career. Start by networking within your existing circles, including friends, family, and professional connections, to find potential clients. Utilize social media platforms, particularly LinkedIn, to showcase your accounting services and engage with SME owners. Consider offering a free initial financial health check to new clients to demonstrate your value. Join online communities and forums for small business owners who need accounting support. Consistently delivering accurate financial reports and maintaining good client relationships will lead to referrals and a growing client base.",
    },
    {
        sliderImage: Images.CareerCardImageSix,
        sliderTitle: 'Essential Skills for Accounting & Finance Professionals',
        sliderDescription: "To thrive as an accounting or finance professional, certain skills are indispensable. First, strong numerical accuracy and attention to detail are crucial for managing financial records correctly. Proficiency in accounting software like QuickBooks, Xero, or Sage is essential for modern practice. Excellent organisational abilities help manage multiple client accounts and deadlines effectively. Familiarity with tax regulations and compliance requirements will set you apart. Time management is also vital for delivering monthly reports and payroll on time. Lastly, strong communication skills will help you explain financial data clearly to non-finance clients. Continuously improving these skills will enhance your service quality and client satisfaction."
    },
    {
        sliderImage: Images.CareerCardImageSeven,
        sliderTitle: 'Getting Started as an Accounting & Finance Professional',
        sliderDescription: "Starting a freelance accounting or finance career is an excellent option for those seeking flexibility and the opportunity to work from anywhere. To begin, assess your qualifications and identify the services you can offer, such as bookkeeping, payroll, tax preparation, or financial reporting. Create a professional online presence with a well-crafted LinkedIn profile and a SmartCV on Workason Accounting highlighting your accounting expertise. Join Workason Accounting to connect with clients looking for verified accounting professionals. Invest in reliable accounting software subscriptions and a stable internet connection to work efficiently. As you gain experience, collect client testimonials to build credibility and get SkillStamped on Workason Accounting to attract more clients."
    },
];

const ITEMS_PER_PAGE = 4;

const PaginationSection: React.FC = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [filteredArticles, setFilteredArticles] = useState(jobData)
    const totalPages = Math.ceil(filteredArticles.length / ITEMS_PER_PAGE);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    useEffect(() => {
        if (jobData.length > ITEMS_PER_PAGE) {
            setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
        }
    }, [totalPages]);

    const displayedJobs = filteredArticles.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    return (
        <div className='lg:p-[4rem]'>
            <section className='py-[2rem]'>
                <div className="flex justify-center">
                    <div className="grid lg:grid-cols-2 md:grid-cols-2 lg:items-center justify-center gap-[1rem] space-y-[2rem] sm:space-y-0 py-[4rem]">
                        {displayedJobs.map((job, index) => (
                            <CareerTipSCardSection
                                key={index}
                                sliderDescription={job.sliderDescription}
                                sliderImage={job.sliderImage}
                                sliderTitle={job.sliderTitle}
                            />
                        ))}
                    </div>
                </div>
            </section>
            <CareerPagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    );
};

export default PaginationSection;
